<div
  class="footer"
  [class.temp-footer-style]="storefrontId === 78"
  [class.custom-footer-text]="footerTextColor()"
  [style.background-color]="footerBackgroundColor()"
>
  @if (trustedHtml) {
    <div class="ql-editor" [innerHTML]="trustedHtml"></div>
  }
  <div class="footer-logo">
    <a [routerLink]="['/']">
      <img class="logo-img cursor-pointer" [src]="logo.src" alt="logo" />
    </a>
  </div>
  <div class="footer-links">
    <ul>
      @for (item of menuItems; track item.label) {
        <li>
          <a
            [style.color]="footerTextColor()"
            [routerLink]="getRouterLink(item)"
            routerLinkActive="menu-item-title"
            ariaCurrentWhenActive="page"
          >
            {{ item.label }}
          </a>
        </li>
      }
    </ul>
  </div>
  @if (copyright()) {
    <p class="rights" [style.color]="footerTextColor()">{{ copyright() }}</p>
  }
  <div class="social-icons" [style.background-color]="footerBackgroundColor()">
    @for (link of socialLinks(); track link.name) {
      <a [href]="sanitizeUrl(link.url)" target="_blank" rel="noopener noreferrer">
        <img [src]="getSocialIconPath(link.name)" [alt]="link.name" height="20px" width="20px" />
      </a>
    }
  </div>
</div>
